import { render, staticRenderFns } from "./ClothingDetail.vue?vue&type=template&id=bdff6dea&"
import script from "./ClothingDetail.vue?vue&type=script&lang=js&"
export * from "./ClothingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports